import _ from 'lodash'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import {
  Grid, Menu, Sidebar, Button,
  Segment, Confirm, Sticky, Transition
} from 'semantic-ui-react'

const TopGrid = (props) => {
  return (
    <Grid
      style={{/*minHeight: '100%',*/ margin: '1%'}}
      className={'nopadding'}
      columns={'equal'}>
      {props.children}
    </Grid>
  )
}
TopGrid.displayName = 'TopDir'
TopGrid.propTypes = {
  children: PropTypes.any
}

export class MinimizableMenu extends PureComponent {
  static propTypes = {
    mini: PropTypes.bool,
    menuItems: PropTypes.arrayOf(PropTypes.object),
    stickyContextRef: PropTypes.any,
    onOpenMenuClick: PropTypes.func,
    onLogoutClick: PropTypes.func,
  }
  render () {
    const {
      mini,
      menuItems,
      stickyContextRef,
      onOpenMenuClick,
      onLogoutClick,
      ...menuCommonProps
    } = this.props
    let menuProps = {
      icon: mini,
      items: _.map(menuItems, (item, i) => (
        mini ? {..._.omit(item, ['name']), key: i} : {...item, key: i }))
    }

    const menuHeader = {
      disabled: true,
      header: true,
      content: (
        <Button
          attached='top'
          size='tiny'
          icon='content'
          title='open menu'
          onClick={onOpenMenuClick} />
      )
    }
    const menuFooter = {
      disabled: true,
      header: true,
      content: (
        <Button
          attached='bottom'
          size='mini'
          icon='sign out'
          title='open menu'
          onClick={onLogoutClick} />
      )
    }
    if(onOpenMenuClick) menuProps.items.unshift(menuHeader)
    if(onLogoutClick) menuProps.items.push(menuFooter)

    return (
      <Sticky
        active={!_.isUndefined(stickyContextRef)}
        context={stickyContextRef}
        offset={40}>
        <Menu {...menuProps} {...menuCommonProps} borderless/>
      </Sticky>
    )
  }
}

export class TopBar extends PureComponent {
  static propTypes = {
    onLogout: PropTypes.func,
    onToggleSideMenu: PropTypes.func,
    topMenuExtraProps: PropTypes.object,
    confirmMessage: PropTypes.string,
  }
  state = {
    confirmOpen: false
  }
  onLogoutClick = () => { this.setState({confirmOpen: true}) }
  onConfirmCancel = () => { this.setState({confirmOpen: false}) }
  onConfirmOK = () => {
    this.setState({confirmOpen: false})
    if(this.props.onLogout)
      this.props.onLogout()
  }

  render () {
    return (
      <Menu {...this.props.topMenuExtraProps}>
        {this.props.onToggleSideMenu &&
         <Menu.Item
           link={true}
           icon='content'
           title='open menu'
           onClick={this.props.onToggleSideMenu} />
        }
        <Menu.Item
          link={true}
          onClick={this.onLogoutClick}
          icon='sign out'
          title='sign out'
          position='right' />
        <Confirm
          open={this.state.confirmOpen}
          header={this.props.confirmMessage || 'Sign out'}
          onCancel={this.onConfirmCancel}
          onConfirm={this.onConfirmOK}
        />
      </Menu>
    )
  }
}

export class NavSidebarPusher extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    menuItems: PropTypes.arrayOf(PropTypes.object),
    fixedMenus: PropTypes.bool,
    onLogout: PropTypes.func

  }
  state = {
    sideBarMini: true,
    fixedMenus: false
  }

  onToggleSideMenu = () => {
    this.setState({
      sideBarMini: !this.state.sideBarMini
    })
  }

  handleContextMainContainerRef = (mainContainerContextRef) => {
    this.setState({ mainContainerContextRef })
  }
  handleContextRootContainerRef = (rootContainerContextRef) => {
    this.setState({ rootContainerContextRef })
  }

  renderSideMenu = (
    fixedSideProps, sideBarMini,
    mainContainerContextRef, menuItems
  ) => {
    return (
      <MinimizableMenu
        {...fixedSideProps}
        initialMarginTop={'56px'}
        stickyContextRef={mainContainerContextRef}
        vertical pointing floated={true}
        mini={sideBarMini}
        menuItems={menuItems} />
    )
  }

  renderMainContainer = () => {
    return (
      <div ref={this.handleContextRootContainerRef}>
        {this.props.children}
      </div>
      ||
      <Segment style={{minHeight: '80vh'}}>MAIN CONTENT VIEW</Segment>
    )
  }

  renderSideMenuAndMainContainer = (
    fixedSideProps, mainContainerProps, fixedMenus,
    menuItems, sideBarMini, mainContainerContextRef
  ) => {
    const sideBarMaxWidth = fixedMenus ? 230 : 215
    const pushableStyle = fixedMenus ? {marginTop: '56px'} : {}
    const sidebarStyle = {maxWidth: sideBarMaxWidth}
    const mainContainerWidth = (this.state.mainContainerContextRef||mainContainerContextRef||{}).clientWidth
    return (
      <Sidebar.Pushable style={pushableStyle}>
        <Sidebar visible={!sideBarMini} style={sidebarStyle}>
          {
            this.renderSideMenu(
              _.extend(fixedSideProps), sideBarMini,
              this.state.mainContainerContextRef||mainContainerContextRef,
              menuItems)
          }
        </Sidebar>
        <Sidebar.Pusher>
          {
            sideBarMini && this.renderSideMenu(
              _.extend(fixedSideProps),
              sideBarMini,
              this.state.mainContainerContextRef||mainContainerContextRef,
              menuItems)
          }
          <div
            {...mainContainerProps}
            style={
              _.extend(
                {},
                sideBarMini ? {marginLeft: '56px'} : {},
                fixedMenus ? {} : {},
                mainContainerWidth && !sideBarMini ? { maxWidth: mainContainerWidth - sideBarMaxWidth} : {}
              )}>
            {this.renderMainContainer(mainContainerProps)}
          </div>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    )
  }

  render () {
    const {
      menuItems
    } = this.props
    const {
      sideBarMini,
      rootContainerContextRef,
    } = this.state

    const fixedMenus = this.state.fixedMenus || this.props.fixedMenus
    const fixedTopProps = {attached: true, size: 'huge'}
    const fixedSideProps = {style: {height: '100%'}}
    //let fixedSideProps = {}
    const mainContainerProps = {ref: this.handleContextMainContainerRef}
    //let mainContainerProps = {}
    if(fixedMenus) {
      fixedTopProps.fixed = 'top'
      fixedTopProps.attached = false
      fixedSideProps.fixed = 'left'
      //fixedSideProps.style.marginTop = '56px'
      // mainContainerProps.style = {marginTop: '48px'}
    }

    return (
      <div style={{height: '100%'}} ref={this.handleContextRootContainerRef}>
        <TopBar
          topMenuExtraProps={fixedTopProps}
          onToggleSideMenu={this.onToggleSideMenu}
          onLogout={this.props.onLogout}
        />
        {
          this.renderSideMenuAndMainContainer(
            fixedSideProps, mainContainerProps, fixedMenus,
            menuItems, sideBarMini, rootContainerContextRef)
        }
      </div>
    )
  }

}


export class NavTwoColumns extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    sideBarMini: PropTypes.bool,
    onLogout: PropTypes.func,
    menuItems: PropTypes.arrayOf(PropTypes.object),
    stickySideMenu: PropTypes.bool,
    stickyTopBar: PropTypes.bool
  }
  state = {
    sideBarMini: _.isBoolean(this.props.sideBarMini) ? this.props.sideBarMini : true,
    confirmOpen: false
  }

  onLogoutClick = () => { this.setState({confirmOpen: true}) }
  onConfirmCancel = () => { this.setState({confirmOpen: false}) }
  onConfirmOK = () => {
    this.setState({confirmOpen: false})
    if(this.props.onLogout) this.props.onLogout()
  }
  handleContextColContainerRef = (colContainerContextRef) => {
    console.log(colContainerContextRef)
    this.setState({ colContainerContextRef })
  }

  render() {
    const { sideBarMini } = this.state
    const { menuItems, stickySideMenu } = this.props
    const sideColWidth = sideBarMini ? 1 : 3
    const sideMinWidth = sideBarMini ? '6rem' : '8rem'
    return (
      <TopGrid>

        <Grid.Column
          stretched
          width={sideColWidth}
          style={{minWidth: sideMinWidth, paddingRight: '0px'}}
        >
          {(stickySideMenu ?
            <div ref={this.handleContextColContainerRef}>
              <MinimizableMenu
                vertical pointing
                stickyContextRef={this.state.colContainerContextRef}
                mini={sideBarMini}
                onOpenMenuClick={() => this.setState({sideBarMini: !sideBarMini})}
                onLogoutClick={this.props.onLogout}
                menuItems={menuItems} />
            </div> :
            <MinimizableMenu
              vertical pointing attached
              mini={sideBarMini}
              onOpenMenuClick={() => this.setState({sideBarMini: !sideBarMini})}
              onLogout={this.props.onLogout}
              menuItems={menuItems} />
          )}
        </Grid.Column>
        <Grid.Column>
          <Grid.Row>{this.props.children}</Grid.Row>
        </Grid.Column>

      </TopGrid>
    )
  }
}


export class NavTwoRowsTwoColumns extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    sideBarMini: PropTypes.bool,
    onLogout: PropTypes.func,
    menuItems: PropTypes.arrayOf(PropTypes.object),
    stickySideMenu: PropTypes.bool,
    stickyTopBar: PropTypes.bool,
    confirmMessage: PropTypes.string
  }
  state = {
    sideBarMini: _.isBoolean(this.props.sideBarMini) ? this.props.sideBarMini : true,
    confirmOpen: false
  }

  onLogoutClick = () => { this.setState({confirmOpen: true}) }
  onConfirmCancel = () => { this.setState({confirmOpen: false}) }
  onConfirmOK = () => {
    this.setState({confirmOpen: false})
    if(this.props.onLogout) this.props.onLogout()
  }
  handleContextColContainerRef = (colContainerContextRef) => {
    console.log(colContainerContextRef)
    this.setState({ colContainerContextRef })
  }
  handleContextTopContainerRef = (topContainerContextRef) => {
    console.log(topContainerContextRef)
    this.setState({ topContainerContextRef })
  }

  onToggleSideMenu = () => {
    this.setState({sideBarMini: !this.state.sideBarMini})
  }

  render() {
    const { sideBarMini } = this.state
    const { menuItems, stickySideMenu, stickyTopBar } = this.props
    const sideMinWidth = sideBarMini ? '5rem' : '8rem'
    const fixedTopProps = { size:'huge' }
    const extraSideMenuProps = {}
    const sideColExtraProps = {
      width: sideBarMini ? 1 : 2,
      style: { minWidth: sideMinWidth, paddingRight: '0px' }
    }
    if (stickyTopBar) {
      sideColExtraProps.style = {...sideColExtraProps.style, marginLeft: '-22px', paddingRight: '0px' }
      fixedTopProps.fixed = 'top'
      //extraSideMenuProps.style = { marginTop: '56px' }
    } else if (stickySideMenu) {
      extraSideMenuProps.onLogoutClick = this.onLogoutClick
    }

    return (
      <TopGrid celled>

        <Grid.Row>
          <Grid.Column stretched>
            <TopBar
              topMenuExtraProps={fixedTopProps}
              onLogout={this.props.onLogout}
              onToggleSideMenu={this.onToggleSideMenu}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={stickyTopBar ? {marginTop: '40px'} : {}}>
          <Grid.Column stretched {...sideColExtraProps}>
            {(stickySideMenu ?
              <div ref={this.handleContextColContainerRef}>
                <MinimizableMenu
                  vertical pointing attached compact
                  stickyContextRef={this.state.colContainerContextRef}
                  mini={sideBarMini}
                  menuItems={menuItems}
                  {...extraSideMenuProps} />
                <Confirm
                  open={this.state.confirmOpen}
                  header={this.props.confirmMessage || 'Sign out'}
                  onCancel={this.onConfirmCancel}
                  onConfirm={this.onConfirmOK}
                />
              </div> :
              <MinimizableMenu
                vertical pointing attached compact
                mini={sideBarMini}
                menuItems={menuItems}
                {...extraSideMenuProps} />
            )}
          </Grid.Column>
          <Grid.Column stretched>
            <Grid.Row stretched>

              {this.props.children}

            </Grid.Row>
          </Grid.Column>
        </Grid.Row>

      </TopGrid>
    )
  }
}

export class NavTwoRowsTwoColumnsWithTransition extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    sideBarMini: PropTypes.bool,
    onLogout: PropTypes.func,
    menuItems: PropTypes.arrayOf(PropTypes.object),
    stickySideMenu: PropTypes.bool,
    stickyTopBar: PropTypes.bool,
    confirmMessage: PropTypes.string
  }
  state = {
    sideBarMini: _.isBoolean(this.props.sideBarMini) ? this.props.sideBarMini : true,
    confirmOpen: false
  }

  onLogoutClick = () => { this.setState({confirmOpen: true}) }
  onConfirmCancel = () => { this.setState({confirmOpen: false}) }
  onConfirmOK = () => {
    this.setState({confirmOpen: false})
    if(this.props.onLogout) this.props.onLogout()
  }
  handleContextColContainerRef = (colContainerContextRef) => {
    console.log(colContainerContextRef)
    this.setState({ colContainerContextRef })
  }
  handleContextTopContainerRef = (topContainerContextRef) => {
    console.log(topContainerContextRef)
    this.setState({ topContainerContextRef })
  }

  onToggleSideMenu = () => {
    this.setState({sideBarMini: !this.state.sideBarMini})
  }

  render() {
    const { sideBarMini } = this.state
    const { menuItems, stickySideMenu, stickyTopBar } = this.props
    const sideMinWidth = sideBarMini ? '5rem' : '8rem'
    const fixedTopProps = { size:'huge' }
    const extraSideMenuProps = {}
    const sideColExtraProps = {
      width: sideBarMini ? 1 : 2,
      style: { minWidth: sideMinWidth, paddingRight: '0px' }
    }
    if (stickyTopBar) {
      sideColExtraProps.style = {...sideColExtraProps.style, marginLeft: '-22px', paddingRight: '0px' }
      fixedTopProps.fixed = 'top'
    } else if (stickySideMenu) {
      extraSideMenuProps.onLogoutClick = this.onLogoutClick
    }

    return (
      <TopGrid celled>

        <Grid.Row>
          <Grid.Column stretched>
            <TopBar
              topMenuExtraProps={fixedTopProps}
              onLogout={this.props.onLogout}
              onToggleSideMenu={this.onToggleSideMenu}
            />
          </Grid.Column>
        </Grid.Row>

        <Transition
          as={Grid.Row}
          style={stickyTopBar ? {marginTop: '40px'} : {}}>

          <Grid.Column stretched {...sideColExtraProps}>
            {(stickySideMenu ?
              <div ref={this.handleContextColContainerRef}>
                <MinimizableMenu
                  vertical pointing attached compact
                  stickyContextRef={this.state.colContainerContextRef}
                  mini={sideBarMini}
                  menuItems={menuItems}
                  {...extraSideMenuProps} />
                <Confirm
                  open={this.state.confirmOpen}
                  header={this.props.confirmMessage || 'Sign out'}
                  onCancel={this.onConfirmCancel}
                  onConfirm={this.onConfirmOK}
                />
              </div> :
              <MinimizableMenu
                vertical pointing attached compact
                mini={sideBarMini}
                menuItems={menuItems}
                {...extraSideMenuProps} />
            )}
          </Grid.Column>

          <Grid.Column stretched>
            <Grid.Row stretched>

              {this.props.children}

            </Grid.Row>
          </Grid.Column>
        </Transition>

      </TopGrid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NavigationDrawerLayout.js